import "../styles/projects.css"
import "../styles/art/nightsky.css"

import { ProjectItem } from "../components/ProjectItem"
import { useEffect } from "react"
import { projectData } from "../const/projectData"
import { NightSky } from "../components/art/NightSky"
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { gsap } from "gsap"
import applyLandscapeAnimation from "../helper/landscapeAnimationHelper"

function PageProjects() {

    useEffect(() => {
        window.scrollTo(0,0)

        let t1 = gsap.timeline({onStart: setScrollTriggers})
        t1.fromTo(".background-projects", {backgroundImage: `linear-gradient(to bottom, black 0%, black 80%, black 100%)`,},
        {
            backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,1) 40%, rgb(19, 6, 3) 60%, rgb(124, 60, 34) 80%, rgb(240, 121, 65) 90%)`,
            duration: 1,
            ease: "power3.in",
        }, 0)
        t1.fromTo(".main-projects__section", {
            y: "-50vh",
            opacity: 0
        },
        {
            y: 0,
            opacity: 1,
            duration: 1,
            stagger: 0.25
        }, 0.25)

    }, [])

    function setScrollTriggers() {
        gsap.registerPlugin(ScrollTrigger)
        let tScrollBackground = gsap.timeline()
        let skyAnimTrigger = ScrollTrigger.create({
            trigger: ".main-projects",
            start: "top top",
            end: "center top",
            scrub: true,
            animation: gsap.fromTo(".sky-background", {
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,1) 30%, rgb(19, 6, 3) 60%, rgb(124, 60, 34) 80%, rgb(240, 121, 65) 90%)`,
            },
            {
                backgroundImage: `linear-gradient(to bottom, rgba(0,0,0,1) 50%, rgb(19, 6, 3) 60%, rgb(26, 15, 11) 100%)`,
                ease: "power2.in",
                duration: 1
            })
        })

        let mountainTrigger = applyLandscapeAnimation({
            trigger: ".main-projects",
            endTrigger: ".main-projects",
            start: "top top",
            end: "40% top",
            y: "50vh"
        })
        tScrollBackground.add(skyAnimTrigger.animation, 0)
        tScrollBackground.add(mountainTrigger.animation, 0)
    }

    const projectCategories = Object.keys(projectData)
    const projectDataItems = Object.values(projectData)
    
    return (
        <>
            <div className="sky-background background-projects"></div>
            <main className="main-projects">
                <NightSky></NightSky>
                <h1>My projects</h1>
                {projectDataItems.map((category, i) => {
                    return (
                        <section className="main-projects__section" key={i}>
                            <h2>{projectCategories[i]}</h2>
                                <div className="projects-pane">
                                    {category.map((project, i) => <ProjectItem info={project} key={i}></ProjectItem>)}
                                </div>
                        </section>
                    )
                })}

                <div className="planet-landscape-container">
                    <div className="planet-ii-mountain-container">
                        <div className="planet-ii-mountain planet-ii-mountain-1"></div>
                    </div>
                    <div className="planet-ii-mountain-container">
                        <div className="planet-ii-mountain planet-ii-mountain-2"></div>
                    </div>
                    <div className="planet-iii-surface"></div>
                </div>
            </main>
        </>
        
    )
}

export default PageProjects